import { render } from "./Join.vue?vue&type=template&id=2e4639b8&ts=true&lang=pug"
import script from "./Join.vue?vue&type=script&lang=ts"
export * from "./Join.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__